import { Link } from "react-router-dom";
import { ArrowRight, Loader2 } from "lucide-react";
import { clock } from "@/lib/voiceSongsApi";

/** Re-done parts of this song: progress, then a link to the new song. */
export default function SectionJobs({ rows, songId }) {
  if (!rows?.length) return null;
  return (
    <ul data-testid="section-jobs" className="mt-4 space-y-2">
      {rows.map((j) => (
        <li key={j.id} data-testid={`section-job-${j.id}`} className="flex flex-wrap items-center gap-3 rounded-2xl border border-violet-300/15 bg-violet-300/[0.05] px-4 py-3 text-[13px]">
          <span className="font-medium">{j.song_id === songId ? "Re-doing" : "Re-done from the original"} {clock(j.start_s)}–{clock(j.end_s)}</span>
          {j.status === "running" ? <span className="flex items-center gap-1.5 text-amber-100"><Loader2 className="h-3.5 w-3.5 animate-spin" /> Working…</span> : null}
          {j.status === "error" ? <span data-testid={`section-job-error-${j.id}`} className="text-rose-200">{j.error}</span> : null}
          {j.status === "done" && j.result && j.result.song_id !== songId ? (
            <Link to={`/create/song/${j.result.song_id}`} data-testid={`section-job-open-${j.id}`} className="ml-auto inline-flex items-center gap-1 font-mono text-[11px] uppercase tracking-[0.16em] text-violet-200 hover:text-white">Open the new version <ArrowRight className="h-3.5 w-3.5" /></Link>
          ) : null}
          {j.status === "done" && j.result?.song_id === songId ? (
            <Link to={`/create/song/${j.song_id}`} data-testid={`section-job-original-${j.id}`} className="ml-auto inline-flex items-center gap-1 font-mono text-[11px] uppercase tracking-[0.16em] text-white/60 hover:text-white">Open the original <ArrowRight className="h-3.5 w-3.5" /></Link>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
